import { defineKey } from '@ha/intl';

import {
  SearchView,
  SuitableForNumberID,
} from '@kamernet/core/ApiClient/Kamernet';

export const SuitableForNumberTranslations: Record<
  SuitableForNumberID,
  string
> = {
  [SuitableForNumberID.Empty]: '',
  [SuitableForNumberID.OnePerson]: defineKey('DMN_ONE'),
  [SuitableForNumberID.TwoPersons]: defineKey('DMN_TWO'),
  [SuitableForNumberID.ThreePersons]: defineKey('DMN_THREE'),
  [SuitableForNumberID.FourPersons]: defineKey('lbl.number_four'),
  [SuitableForNumberID.FivePersons]: defineKey('DMN_FIVE'),
  [SuitableForNumberID.MoreThanFivePersons]: defineKey(
    'search_page.filters.any',
  ),
};

export const SearchViewTranslations: Record<SearchView, string> = {
  [SearchView.Empty]: '',
  [SearchView.List]: defineKey('LBL_SEARCHROOMS_SWITCH_TILE_VIEW'),
  [SearchView.Map]: defineKey('LBL_SEARCHROOMS_SWITCH_MAP_VIEW'),
  [SearchView.Favorite]: '',
};
